import React, {useState} from "react";
import { Form } from "react-bulma-components";
import { Button } from "react-bulma-components";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {getDataFresh} from "../../state/selectors";
import {NotificationContainer, NotificationManager} from "react-notifications";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useSafeSave from "../../hooks/useSafeSave";
import FAIcon from "../Icon/FAIcon";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import { Icon } from "react-bulma-components";
import DeleteWarningModal from "../Modal/DeleteWarningModal";
import useInlineEditButton from "../../hooks/useInlineEditButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";
import {addXeroVat, compareVat, formatXeroData, sendXeroData} from "../../utils";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import {expenseDueDate, formatDate, readableDate} from "../../utils";
import VatSelector from "../Utils/VatSelector";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import ApprovalModal from "./ApproveModal";
import TaxTypePicker from "../Settings/NominalCodes/TaxTypePicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";

const AsyncTypeahead = asyncContainer(Typeahead);

function TransactionRow({
                          transaction,
                          index,
                          onTransactionUpdate,
                          endpoint,
                          onSelectCheck,
                          selected,
                          clearSelected,
                          editDisabled,
                          contact_type,
                          paymentTypes,
                          view,
                          setSelectedTransaction,
                          setCreditModalOpen,
                          trackingOptions,
                          trackingOptionObjects,
                          departments,
                          departmentObjects,
                          approveMultiple,
                          nominalCodes,
                          nominalCodeObjects
                        }) {
  const dateFields = ["invoice_date", "payment_date", "date"];
  const dispatch = useDispatch();
  const [editable, setEditable] = useState(false);
  const [lastEdited, setLastEdited] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [getFilteredData, setGetFilteredData] = useState();
  let dataFresh = useSelector(getDataFresh);

  const accountOptions = [
    { name: "", value: "BLANK"},
    { name: "Hire", value: "hire_account_code"},
    { name: "Sale", value: "sale_account_code"},
    { name: "Workshop", value: "workshop_account_code"},
    { name: "Deposit", value: "deposit_account_code"},
    { name: "Loan", value: "loan_account_code"},
    { name: "Part", value: "part_account_code"},
    { name: "Court", value: "court_account_code"},
    { name: "Movement", value: "movement_account_code"}
  ];

  const customerPaymentOptions = [
        {name:"", value: "BLANK"},
        {name: "BACS", value: "BACS"},
        {name: "CASH", value: "CASH"},
        {name: "CARD", value: "CARD"},
        {name: "DIRECT DEBIT", value: "DIRECT DEBIT"}
    ];

  // const categoryFields = transactionCategories;
  // const categoryObjects = categoryFields.reduce((obj, item) => {
  //   return {
  //     ...obj,
  //     [item["id"]]: item
  //   };
  // }, {});

  const paymentTypeObjects = paymentTypes ? paymentTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};

  // const handleCategoryUpdate = e => {
  //   const toUpdate = {
  //     target: {
  //       name: "category",
  //       value: categoryObjects[e.target.value]
  //     }
  //   };
  //   onChange(toUpdate)
  // };

  const handleNominalCodeChange = e => {
    const toUpdate = {
      target: {
        name: "nominal_code",
        value: nominalCodeObjects[e.target.value]
      }
    };
    onChange(toUpdate);
  }

  const handleTrackingOptionUpdate = e => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: trackingOptionObjects[e.target.value]
      }
    };
    onChange(toUpdate);
  };


  const handleDepartmentUpdate = e => {
    const toUpdate = {
      target: {
        name: "department",
        value: departmentObjects[e.target.value]
      }
    };
    onChange(toUpdate);
  }

  const fixEmptyDates = transactionData => {
    dateFields.forEach(function (date) {
      if (transactionData[date] === "") {
        transactionData[date] = null;
      }
    });
    return transactionData;
  };
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [, setTypeahead] = useState();

  const handleDelete = id => {
    const endpoint = "/api/transactions/" + id;
    const conf = {method: "delete", url: endpoint};
    axios(conf).then(response =>
      dispatch(createSetDataFreshAction(dataFresh + 1))
    );
  };

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=${contact_type}&page_size=40&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleTransactionContactSelect = contact => {
    let newTransaction = {...transaction, contact: contact[0]};
    makeDirty();
    setLastEdited(new Date());
    onTransactionUpdate(index, newTransaction);
  };

  const submitUpdate = (approval, transaction) => {
    transaction.approved = !!approval;
    const url = endpoint + "transactions/update/" + transaction.id;
    const data = fixEmptyDates(transaction);
    const conf = {
      method: "put",
      data,
      url
    };

    return axios(conf)
  };

  const handleApprove = (data) => {
    // takes an array of at least length 1
    if(data.length > 1){
      return approveMultiple(data)
    }
    else if(data.length == 1){
      return submitUpdate(true, data[0])
    }
    else {
      NotificationManager.error("You cannot approve 0 transactions")
    }
  }

  const onApproveClick = e => {
    e.stopPropagation();
    setGetFilteredData(true);
    setApproveModalOpen(true);
  }

  const validator = (transaction) => {
    if(!transaction.nominal_code){
      NotificationManager.warning("Transaction Nominal Code is required");
      return false
    }
    if(!(compareVat(transaction.nominal_code, transaction.invoice_vat))){
      NotificationManager.warning("Vat entered does not match nominal vat");
      // MOVE WHEN POSTING DATA THROUGH AS APPROVED (IF THIS CHECK FAILS THEN POST AS DRAFT)
    }
    if(!transaction.contact.partial_contact){
      if (transaction.type === "IN" && (transaction.invoice_date && transaction.invoice_number)){
        return true;
      } else if (transaction.type === "OUT" && (transaction.invoice_date && transaction.invoice_number)){
        return true;
      } else {
        NotificationManager.warning(
            "You must specify an invoice date and invoice number before approving!",
            "Invoice Date Required",
            10000
        );
      }
    }
    else{
      NotificationManager.warning("Contact must be a full contact");
    }
    return false;
  }

  const getSource = (transaction) => {
    if(transaction.type === "OUT"){
      return "TRE"
    }
    else if(transaction.type === "IN"){
      return "TRI"
    }
  }

  const onTransactionApprove = (e, approval, transaction) => {
    e.stopPropagation();
    //needs to be able to take an array of items
    let allValid = transaction.reduce((current, newVal) => {
      return current && (validator(newVal))
    }, true)
    if(allValid){
      return handleApprove(transaction).then(res => {
          let invoice;
          let source;
          let target;
          if(Array.isArray(res.data)){
            source = getSource(res.data[0])
            if(res.data[0].type === "OUT"){
              target = "PurchaseInvoice"
            }
            else{
              target = "SalesInvoice"
            }
            invoice = formatXeroData(res.data, source)
          }
          else{
            source = getSource(res.data);
            invoice = formatXeroData([res.data], source);
            if(res.data.type === "OUT"){
              target = "PurchaseInvoice"
            }
            else{
              target = "SalesInvoice"
            }
          }
          console.log(invoice);
          if(invoice.XeroDept) {
            sendXeroData(invoice, target).then(res => {
              NotificationManager.success("All data has been sent to xero")
            }).catch(err => {
              NotificationManager.error("There was an error sending")
            })
          }
          setEditable(false);
          dispatch(createSetDataFreshAction(dataFresh + 1));
          clearSelected();
      })
    }
    //shouldnt be able to unapprove an expense?
    // if(!transaction.category.nominal_code){
    //   NotificationManager.warning("Transaction Category Nominal Code is required");
    //   return
    // }
    // if(!transaction.contact.partial_contact) {
    //   if (transaction.type === "IN" && (transaction.invoice_date && transaction.invoice_number)) {
    //     handleApprove(transaction).then(res => {
    //       // let invoice = formatXeroData([res.data], "TRI");
    //       // if(invoice.XeroDept) {
    //       //   sendXeroData(invoice, "SalesInvoice").then(res => {
    //       //     NotificationManager.success("All data has been sent to xero")
    //       //   }).catch(err => {
    //       //     NotificationManager.error("There was an error sending")
    //       //   })
    //       // }
    //       // console.log(invoice);
    //       setEditable(false);
    //       dispatch(createSetDataFreshAction(dataFresh + 1));
    //       clearSelected();
    //     })
    //   } else if (transaction.type === "OUT" && (transaction.invoice_date && transaction.invoice_number)) {
    //     submitUpdate(approval, transaction).then(res => {
    //       // let invoice = formatXeroData([res.data], "TRE");
    //       // if(invoice.XeroDept) {
    //       //   sendXeroData(invoice, "PurchaseInvoice").then(res => {
    //       //     NotificationManager.success("All data has been sent to xero")
    //       //   }).catch(err => {
    //       //     NotificationManager.error("There was an error sending")
    //       //   })
    //       // }
    //       // console.log(invoice);
    //       setEditable(false);
    //       dispatch(createSetDataFreshAction(dataFresh + 1));
    //       clearSelected();
    //     })
    //   } else {
    //     NotificationManager.warning(
    //         "You must specify an invoice date and invoice number before approving!",
    //         "Invoice Date Required",
    //         10000
    //     );
    //   }
    // }
    // else {
    //   NotificationManager.warning("The contact must be fully setup")
    }
    /*
    if (transaction.payment_date && transaction.invoice_number && (transaction.type === 'IN' ? /^\d+$/.test(transaction.invoice_number) : true) || !approval) {
      submitUpdate(approval).then(clearSelected);
    } else {
      NotificationManager.warning(
        "You must specify a payment date and invoice number before approving!",
        "Payment Date Required",
        10000
      );
    }
    */
  //}

  const onSave = e => {
    return submitUpdate(false, transaction).then( () => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    }).catch(err => {
      console.log(err);
      NotificationManager.error("There was an error saving Transaction")
    });
  };

  const checkUpdated = () => {
    return axios.get(endpoint + "transactions/" + transaction.id).then(newTransaction => {
      return newTransaction.data.last_saved === transaction.last_saved;
    });
  };

  const [makeDirty, safeSave] = useSafeSave(
    onSave,
    lastEdited,
    undefined,
    checkUpdated
  );

  const onChange = e => {
    makeDirty();
    setLastEdited(new Date());
    let newTransaction = {...transaction};
    newTransaction[e.target.name] = e.target.value;
    if (e.target.name === 'amount') {
      newTransaction.vat = Math.round((e.target.value * 0.2) * 100) / 100
    }
    if (e.target.name === 'invoice_amount') {
      newTransaction.invoice_vat = Math.round((e.target.value * 0.2) * 100) / 100
    }
    onTransactionUpdate(index, newTransaction);
  };

  const onCheckboxChange = e => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: !transaction[e.target.name]
      }
    };
    onChange(toUpdate);
  }

  const onCheck = e => {
    e.stopPropagation();
    onSelectCheck(transaction);
  };
  const onTypeChange = e => {
    let toUpdate = {
      target: {
        name: "payment_type",
        value: paymentTypeObjects[e.target.value]
      }
    }
    onChange(toUpdate);
  }
  const onStockCheck = e => {
    e.stopPropagation();
    transaction.from_stock = !transaction.from_stock;
    const url = endpoint + "transactions/update/" + transaction.id;
    const data = fixEmptyDates(transaction);
    const conf = {
      method: "put",
      data,
      url
    };

    return axios(conf).then(() => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };

  const handleDueDate = () => {
    let date = expenseDueDate(transaction, "invoice_date", "contact");
    if(date){
      return readableDate(formatDate(date));
    }
    else{
      return ""
    }
  }

  return (
    <tr
      className="small-row-black"
      key={transaction.id}
    >
      <td>{transaction.id}</td>
      {useEditableTableDateCell({
        propName: "date",
        value: transaction.date,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        disabled: editDisabled,
        inlineEdit: false
      })}
      {useEditableTableTextAreaCell({
        propName: "description",
        value: transaction.description,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        disabled: editDisabled,
        inlineEdit: false
      })}
      <td
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <Form.Control>

          <Form.Field className="has-addons">
            <AsyncTypeahead
              useCache={false}
              id="typeahead"
              labelKey="display_name"
              minLength={2}
              name={"contact"}
              onSearch={handleSearch}
              onChange={handleTransactionContactSelect}
              placeholder={"Search Contact"}
              options={searchData}
              ref={typeahead => setTypeahead(typeahead)}
              className="typeahead"
              isLoading={isLoading}
              selected={
                transaction.contact && transaction.contact.id ? [transaction.contact] : []
              }
              disabled={!editable}
            />
          </Form.Field>
        </Form.Control>
      </td>
      {/*{useEditableTableTextCell({*/}
      {/*  propName: "type",*/}
      {/*  value: transaction.type,*/}
      {/*  onChange,*/}
      {/*  onSave: safeSave,*/}
      {/*  editable,*/}
      {/*  setEditable,*/}
      {/*  disabled: editDisabled*/}
      {/*})}*/}
      <td>
        <DepartmentSelector
          name={"department"}
          value={transaction.department}
          editable={editable}
          setEditable={setEditable}
          onChange={handleDepartmentUpdate}
          inlineEdit={false}
          disabled={!editable}
          blank={false}
          classname={"small-column"}
          options={departments}
        />
      </td>
      <td
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <TrackingOptionsPicker
          name={"tracking_option"}
          blank={true}
          value={transaction.tracking_option}
          editable={editable}
          setEditable={setEditable}
          inlineEdit={!transaction.approved}
          onSave={onSave}
          onChange={handleTrackingOptionUpdate}
          options={trackingOptions}
          disabled={!editable || transaction.approved}
        />
      </td>
      {view === "OUT" &&
      <td>
        {<PaymentTypePicker
          options={paymentTypes}
          editable={editable}
          setEditable={setEditable}
          disabled={!editable}
          inlineEdit={false}
          value={transaction.payment_type}
          blank={true}
          onChange={onTypeChange}
          className={"small-column"}
        />}
      </td>
      }
      {/*<td*/}
      {/*  onClick={e => {*/}
      {/*    e.stopPropagation();*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Form.Control>*/}
      {/*    <Form.Field className="has-addons">*/}
      {/*      <Form.Control>*/}
      {/*        <Form.Select*/}
      {/*          onChange={handleCategoryUpdate}*/}
      {/*          name="type"*/}
      {/*          value={transaction.category ? transaction.category.id : transactionCategories[0].id}*/}
      {/*          disabled={!editable}*/}
      {/*        >*/}
      {/*          {categoryFields.map(value => (*/}
      {/*            <option key={value.id} value={value.id}>*/}
      {/*              {value.name}*/}
      {/*            </option>*/}
      {/*          ))}*/}
      {/*        </Form.Select>*/}
      {/*      </Form.Control>*/}
      {/*    </Form.Field>*/}
      {/*    <p className="small-row-black has-text-centered">*/}
      {/*      {transaction.supplier && transaction.supplier.transactions_contact_number}*/}
      {/*    </p>*/}
      {/*  </Form.Control>*/}
      {/*</td>*/}
      {view === "IN" &&
        <td>
          <Form.Select
            name={"customer_account"}
            disabled={!editable}
            value={transaction.customer_account}
            onChange={onChange}
          >
            {accountOptions.map((option) => (
                <option value={option.value}>{option['name']}</option>
            ))}
          </Form.Select>
        </td>
      }
      <td onClick={e => e.stopPropagation()}>
        <NominalCodePicker
          inlineEdit={false}
          editable={!editable}
          onChange={handleNominalCodeChange}
          name={"nominal_code"}
          options={nominalCodes}
          disabled={!editable || transaction.approved}
          value={transaction.nominal_code}
          blank={true}
        />
      </td>
      {useEditableTableCostCell({
        propName: "amount",
        value: transaction.amount,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        disabled: editDisabled,
        inlineEdit: false
      })}

      {useEditableTableDateCell({
        propName: "invoice_date",
        value: transaction.invoice_date,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        disabled: editDisabled,
        inlineEdit: false
      })}
      {useEditableTableTextCell({
        propName: "invoice_number",
        value: transaction.invoice_number,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        disabled: editDisabled,
        inlineEdit: false
      })}
      {useEditableTableCostCell({
        propName: "invoice_amount",
        value: transaction.invoice_amount,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        disabled: editDisabled,
        inlineEdit: false
      })}
      <td>
        <TaxTypePicker
          onChange={onChange}
          name={"invoice_vat"}
          disabled={!editable || editDisabled}
          value={transaction.invoice_vat}
        />
      </td>
      <td>
        <Form.Control>
          <Form.Input
            className="small-row-black"
            type="text"
            name="invoice_total"
            value={
              addXeroVat(transaction.invoice_vat, transaction.invoice_amount)
            }
            disabled={true}
            readonly={true}
          />
        </Form.Control>
      </td>
      {view === "IN" &&
          <td>
            <Form.Input
              type={"number"}
              value={transaction.customer_paid_amount}
              onChange={onChange}
              disabled={!editable}
              name={"customer_paid_amount"}
            />
          </td>
      }
      {view === "IN" &&
        <td>
          <Form.Select
            name={"customer_payment_method"}
            value={transaction.customer_payment_method}
            disabled={!editable}
            onChange={onChange}
          >
            {customerPaymentOptions.map(method => (
                <option value={method.value}>{method.name}</option>
            ))}
          </Form.Select>
        </td>
      }
      {view === "OUT" && <td>{handleDueDate()}</td>}
      {/*{useEditableTableDateCell({*/}
      {/*  propName: "payment_date",*/}
      {/*  value: transaction.payment_date,*/}
      {/*  onChange,*/}
      {/*  onSave: safeSave,*/}
      {/*  editable,*/}
      {/*  setEditable,*/}
      {/*  disabled: editDisabled*/}
      {/*})}*/}
      <td>
        <Form.Checkbox
          name={"ignore_in_figures"}
          checked={transaction.ignore_in_figures}
          disabled={!editable}
          onChange={onCheckboxChange}
        />
      </td>
      {useEditableTableTextAreaCell({
        propName: "comments",
        value: transaction.comments,
        onChange,
        onSave: safeSave,
        editable,
        setEditable
      })}
      <td>
        <Form.Field>
          <Form.Input
            disabled={true}
            name={"creator"}
            value={transaction.creator ? `${transaction.creator.first_name} ${transaction.creator.last_name}` : ""}
          />
        </Form.Field>
      </td>
      {editDisabled && <td>{transaction.approved && transaction.approver ? `${transaction.approver.first_name} ${transaction.approver.last_name}` : ""}</td>}
      <td>
      {useInlineEditButton({show: (!transaction.approved), editable, setEditable, onSave: safeSave})}
      </td>
      <td onClick={e => e.stopPropagation()}>
        <Form.Field>
          <Form.Control className="table-checkbox">
            <Form.Checkbox
              checked={selected}
              type="checkbox"
              onClick={onCheck}
              readOnly
            />
          </Form.Control>
        </Form.Field>
      </td>
      {transaction.approved && false &&
      <td className="float-right">
        <Button
          color="warning"
          data-testid={`submit-transaction-approve${transaction.id}`}
          onClick={(e) => onTransactionApprove(e, false)}
        >
          <FAIcon size="small" icon={["fas", "times"]}/>
        </Button>
      </td>
      }
      {!transaction.approved &&
      <td className="float-right">
        <Button
          color="success"
          data-testid={`submit-transaction-approve${transaction.id}`}
          onClick={(e) => onApproveClick(e)}
        >
          <FAIcon size="small" icon={["fas", "check"]}/>
        </Button>
      </td>
      }
      {transaction.approved &&
        <td>
          <Button
            color={"warning"}
            onClick={() => {
              setSelectedTransaction(transaction);
              setCreditModalOpen(true);
            }}
          >
            Credit
          </Button>
        </td>
      }
      {(!transaction.approved) &&
      <td className={"is-narrow"}>
        <Button
          color={"danger"}
          onClick={() => {
            setDeleteModalOpen(true);
          }}
        >
          X
        </Button>
      </td>
      }
      <DeleteWarningModal
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        onDelete={() => handleDelete(transaction.id)}
      />
      {getFilteredData &&
        <ApprovalModal
          selectedTransaction={transaction}
          show={approveModalOpen}
          setShow={setApproveModalOpen}
          getFilteredData={getFilteredData}
          endpoint={endpoint}
          onApprove={onTransactionApprove}
          validator={validator}
          setGetFilteredData={setGetFilteredData}
          paymentTypes={paymentTypes}
          paymentTypeObjects={paymentTypeObjects}
          onSave={submitUpdate}
          dataFresh={dataFresh}
          trackingOptions={trackingOptions}
          trackingOptionObjects={trackingOptionObjects}
          type={view}
          nominalCodes={nominalCodes}
          nominalCodeObjects={nominalCodeObjects}
        />
      }
    </tr>
  );
}

export default TransactionRow;
